import React, { useEffect, useState, useLocation } from "react";
import './Home.css';
import Navbar from '../Navbar/Navbar';
import Pool from '../../UserPool'

export const Home = (props) => {
    const [name, setName] = useState('');
    const [university, setUniversity] = useState('');
    const [course, setCourse] = useState('');

    const [fileData, setFileData] = useState('');

    let accessToken = null;
    const user = Pool.getCurrentUser();
    if (user) {
        user.getSession((err, session) => {
            if (err) {
                return
            } else {
                accessToken = session.getAccessToken().getJwtToken()
            }
        })
    } else {
        console.error("user not found")
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        getFilesInfo();

    }

    const getFilesInfo = () => {
        let path = `https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/get-file-names?&uni=${university}&course=${course}&file=${name}`
        fetch(path, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
                //'authorization': accessToken,
            },
        })
            .then(response => response.json())
            .then(response => {
                const fileDetails = response.map(fileDetail => (
                    <div className="card" >
                    <a className='card-download' href={`https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/file-download?file=${fileDetail['file_name']}`}>
                    <img className="thumbnailImage" src={`https://bxgf5nutxg.execute-api.us-east-2.amazonaws.com/notable-dev/thumbnail-download?file=${fileDetail['file_name']}`} alt="icons" />
                    <h2>{fileDetail['file_name']}</h2>
                    </a>
                    <p>{fileDetail['university']}</p>
                    <p>{fileDetail['course']}</p>
        
                    </div>
                ));
                setFileData(fileDetails);
            })
    }
    useEffect(() => {
        // 👇️ this only runs once

        // 👇️ fetch data from remote API
        getFilesInfo();
    }, []); // 👈️ empty dependencies array

    return (
        // body
        <div>
            {/* top bar */}
            <Navbar />
            <div>
                <form className="upload-form" onSubmit={(handleSubmit)}>
                    <div className="flex-container">
                        <div className="flex-child">
                            <label className="upload-labels" htmlFor="name">Try Searching Our Database:</label>
                            <br />
                            <input value={name} onChange={(e) => {setName(e.target.value); getFilesInfo();}} type="text" id="name" className="upload-input" placeholder="Document Name" />
                            <br />
                            <br />
                            <br />
                            <button className="button" type="submit">Search</button>
                        </div>

                        <div className="flex-child">
                            <label className="upload-labels" htmlFor="filter">Filter Your Search:</label>
                            <br />
                            <input value={university} onChange={(e) => {setUniversity(e.target.value); getFilesInfo();}} type="text" className="upload-input" placeholder="University/School" />
                            <br />
                            {/* <br />
                            <br />
                            <label className="upload-labels" for="course">Course:</label> */}
                            <input value={course} onChange={(e) => {setCourse(e.target.value); getFilesInfo();}} type="text" className="upload-input" placeholder="Course/Subject" />
                        </div>
                    </div>
                </form>

                <div class="card-container">
                {fileData}
                </div>

            </div>

        </div>
    )
}
export default Home;
